module.exports = __webpack_public_path__ + "media/images/client/AdCatalog/banner-filter-subscription-3582ca86c56e7aee480909eb97284e8b.svg";